module.exports = new __parcel__URL__("city-2.d22e7999.png").toString();